export default __webpack_public_path__ + "static/media/property_985.0365d99b.png";